import { api } from '@/utils/api';

export const useGenerateUploadUrlMutation = () => {
  return api.audioFile.generateUploadUrl.useMutation({});
};

export const useMakePublicAudioFileUrlMutation = () => {
  return api.audioFile.makePublicAudioFileUrl.useMutation({});
};

export const useGenerateAiAudioMutation = () => {
  return api.audioFile.generateAiAudio.useMutation({});
};

export const useContactGenerateVoiceNoteAudioMutation = () => {
  return api.contact.generateVoiceNoteAudio.useMutation({});
};

export const useContactApproveVoiceNoteStepMutation = () => {
  return api.contact.approveVoiceNoteStep.useMutation({});
};

export const useContactCreateVoiceNoteStepMutation = () => {
  return api.contact.createVoiceNoteStep.useMutation({});
};